import {
  INFLUENCER_LIST_QUERY_KEY,
  INFLUENCER_REQUESTS_QUERY_KEY,
} from "@entities/influencer/lib/constants";
import { useMutation } from "@shared/lib/hooks";
import { InfluencerService } from "../lib/services/manage.influencer.requests.service";
import { INFLUENCER_REQUEST_FACETS } from "../lib/constants";

export function useRejectInfluencer() {
  const {
    mutate: rejectInfluencer,
    isLoading: isRejecting,
    isSuccess: isRejected,
    isError: isRejectFailed,
  } = useMutation({
    mutationFn: async ({
      influencerAgencyRequestId,
      remarks,
    }: {
      influencerAgencyRequestId: string;
      remarks?: string;
    }) => {
      return await InfluencerService.rejectInfluencer(
        influencerAgencyRequestId,
        remarks
      );
    },
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c) => {
      // retrigger request facets on reject to get the updated pending count
      setTimeout(() => {
        c.invalidateQueries({
          queryKey: [...INFLUENCER_REQUEST_FACETS],
        });
        c.invalidateQueries({
          queryKey: [...INFLUENCER_REQUESTS_QUERY_KEY],
        });
      }, 1000);
    },
  });

  return {
    rejectInfluencer,
    isRejecting,
    isRejected,
    isRejectFailed,
  };
}
